/**
 * JS handle course review
 *
 * @since 4.0.0
 * @version 1.0.3
 */
import * as lpUtils from './utils.js';
import * as lpToastify from './lpToastify.js';

class CourseReview {
	static selectors = {
		classLoadMore: 'course-review-load-more',
		classLPTarget: '.lp-target',
		classCourseReviewsList: '.course-reviews-list',
		classReviewStars: '.review-stars',
		classChooseStar: '.choose-star',
		classWriteReview: '.write-a-review',
		classCourseReviewWrapper: '.course-review-wrapper',
		classClose: '.close',
		classSubmitReview: '.submit-review',
		classReviewForm: 'form.review-form',
		classReviewFields: '.review-fields',
	};

	init() {
		this.events();
	}

	events() {
		if ( CourseReview._loadedEvents ) {
			return;
		}
		CourseReview._loadedEvents = true;

		lpUtils.eventHandlers( 'click', [
			{
				selector: `.${ CourseReview.selectors.classLoadMore }:not(.loading)`,
				class: this,
				callBack: this.loadMoreReview.name,
			},
			{
				selector: CourseReview.selectors.classWriteReview,
				class: this,
				callBack: this.showFormReview.name,
			},
			{
				selector: CourseReview.selectors.classChooseStar,
				class: this,
				callBack: this.choiceStar.name,
			},
			{
				selector: CourseReview.selectors.classClose,
				class: this,
				callBack: this.closeFormReview.name,
			},
			{
				selector: CourseReview.selectors.classSubmitReview,
				class: this,
				callBack: this.submitFormReview.name,
			},
		] );

		document.addEventListener( 'mouseover', ( e ) => {
			this.handleStarHover( e.target );
		} );
	}

	loadMoreReview( args ) {
		const { target } = args;
		const btnLoadMore = target.closest(
			`.${ CourseReview.selectors.classLoadMore }:not(.loading)`
		);
		if ( ! btnLoadMore ) {
			return;
		}

		lpUtils.lpSetLoadingEl( btnLoadMore, true );

		const elLPTarget = btnLoadMore.closest(
			CourseReview.selectors.classLPTarget
		);
		if ( ! elLPTarget ) {
			return;
		}

		const dataObj = JSON.parse( elLPTarget.dataset.send );
		const dataSend = { ...dataObj };
		if ( ! dataSend.args.hasOwnProperty( 'paged' ) ) {
			dataSend.args.paged = 1;
		} else {
			dataSend.args.paged++;
		}
		elLPTarget.dataset.send = JSON.stringify( dataSend );

		const callBack = {
			success: ( response ) => {
				const { data } = response;
				const paged = parseInt( data.paged );
				const totalPages = parseInt( data.total_pages );

				const newEl = document.createElement( 'div' );
				newEl.innerHTML = data.content || '';
				const elListCourse = elLPTarget.querySelector(
					CourseReview.selectors.classCourseReviewsList
				);

				elListCourse.insertAdjacentHTML(
					'beforeend',
					newEl.querySelector(
						CourseReview.selectors.classCourseReviewsList
					).innerHTML
				);

				if ( paged >= totalPages - 1 ) {
					btnLoadMore.remove();
				}
			},
			error: ( error ) => {
				console.log( error );
			},
			completed: () => {
				lpUtils.lpSetLoadingEl( btnLoadMore, false );
			},
		};

		window.lpAJAXG.fetchAJAX( dataSend, callBack );
	}

	showFormReview( args ) {
		const { target } = args;
		const elBtnShowForm = target.closest(
			CourseReview.selectors.classWriteReview
		);
		if ( ! elBtnShowForm ) {
			return;
		}

		const form = document.querySelector(
			CourseReview.selectors.classCourseReviewWrapper
		);
		if ( ! form ) {
			return;
		}

		form.classList.add( 'active' );
	}

	choiceStar( args ) {
		const { target } = args;
		const elChoiceStar = target.closest(
			CourseReview.selectors.classChooseStar
		);
		if ( ! elChoiceStar ) {
			return;
		}

		const form = target.closest( 'form' );
		const elRatingChose = form
			? form.querySelector( 'input[name="rating"]' )
			: null;
		if ( elRatingChose ) {
			elRatingChose.value = elChoiceStar.dataset.star;
		}
	}

	closeFormReview( args ) {
		const { e, target } = args;
		const elClose = target.closest( CourseReview.selectors.classClose );
		if ( ! elClose ) {
			return;
		}

		const elFormWrapper = elClose.closest(
			CourseReview.selectors.classCourseReviewWrapper
		);
		if ( ! elFormWrapper ) {
			return;
		}

		e.preventDefault();
		elFormWrapper.classList.remove( 'active' );
	}

	submitFormReview( args ) {
		const { e, target } = args;
		const elBtnSubmit = target.closest(
			CourseReview.selectors.classSubmitReview
		);
		if ( ! elBtnSubmit ) {
			return;
		}

		const form = elBtnSubmit.closest(
			CourseReview.selectors.classReviewForm
		);
		if ( ! form ) {
			return;
		}

		e.preventDefault();

		lpUtils.lpSetLoadingEl( elBtnSubmit, 1 );

		const elLPTarget = elBtnSubmit.closest(
			CourseReview.selectors.classLPTarget
		);
		if ( ! elLPTarget ) {
			return;
		}

		const dataObj = JSON.parse( elLPTarget.dataset.send );
		const dataSend = { ...dataObj };
		const courseId = dataSend.args.course_id;
		dataSend.args = lpUtils.mergeDataWithDatForm( form, dataSend.args );
		if ( courseId ) {
			dataSend.args.course_id = courseId;
		}

		const callBack = {
			success: ( response ) => {
				const { data, status, message } = response;

				lpToastify.show( message, status );

				if ( 'success' === status ) {
					setTimeout( () => {
						window.location.reload();
					}, 1000 );
				}
			},
			error: ( error ) => {
				lpToastify.show( error.message || error, 'error' );
			},
			completed: () => {
				lpUtils.lpSetLoadingEl( elBtnSubmit, false );
			},
		};

		window.lpAJAXG.fetchAJAX( dataSend, callBack );
	}

	/**
	 * Show rating when hover on star
	 * Show rating choice when click on star
	 */
	handleStarHover( target ) {
		const elChooseStar = target.closest(
			CourseReview.selectors.classChooseStar
		);
		if ( elChooseStar ) {
			const starNumber = parseInt( elChooseStar.dataset.star );
			const elReviewStars = elChooseStar.closest(
				CourseReview.selectors.classReviewStars
			);
			this.updateStarHover( elReviewStars, starNumber );
		} else {
			const elReviewFields = document.querySelectorAll(
				CourseReview.selectors.classReviewFields
			);
			if ( ! elReviewFields.length ) {
				return;
			}

			elReviewFields.forEach( ( elReviewField ) => {
				const elRatingChoice = elReviewField.querySelector(
					'input[name="rating"]'
				);
				const starChoice = elRatingChoice ? elRatingChoice.value : 0;
				const elReviewStars = elReviewField.querySelector(
					CourseReview.selectors.classReviewStars
				);
				this.updateStarHover( elReviewStars, starChoice );
			} );
		}
	}

	updateStarHover( elReviewStars, starNumber ) {
		if ( ! elReviewStars ) {
			return;
		}

		for ( let i = 1; i < 6; i++ ) {
			const elReviewStar = elReviewStars.querySelector(
				`li[data-star="${ i }"]`
			);
			if ( ! elReviewStar ) {
				continue;
			}

			const elReviewStarSpan = elReviewStar.querySelector( 'span' );
			if ( ! elReviewStarSpan ) {
				continue;
			}

			if ( i <= starNumber ) {
				elReviewStarSpan.classList.add( 'hover' );
			} else {
				elReviewStarSpan.classList.remove( 'hover' );
			}
		}
	}
}

const courseReview = new CourseReview();
courseReview.init();
